import { useAlert } from '@ads/components-react';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { useDeleteApiV1ExamId } from '@/shared/api/generated';

/**
 * Hook para excluir uma prova via DELETE /api/v1/exam/{id}.
 *
 * Invalida a query de listagem de provas após sucesso.
 *
 * @returns Handler de exclusão e estado de loading
 */
export function useDeleteExam() {
  const queryClient = useQueryClient();
  const { alert } = useAlert();
  const { t } = useTranslation('examManagement');

  const mutation = useDeleteApiV1ExamId({
    mutation: {
      onSuccess: () => {
        void queryClient.invalidateQueries({ queryKey: ['exam-grid'] });
        alert({ alertType: 'success', title: t('toast.deleteSuccess') });
      },
      onError: () => alert({ alertType: 'warning', title: t('toast.error') }),
    },
  });

  const deleteExam = (id: number) => {
    mutation.mutate({ id });
  };

  return { deleteExam, isLoading: mutation.isPending } as const;
}
